"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonOptionCard = require("@mmc/common-option-card");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _text = require("@mmc/text");
var _carSelectorGrid = _interopRequireDefault(require("./car-selector-grid.props/car-selector-grid.defaultProps"));
var _carSelectorGrid2 = require("./car-selector-grid.props/car-selector-grid.propTypes");
var _carSelectorPrice = _interopRequireDefault(require("./car-selector-price"));
var _carSelectorTile = _interopRequireDefault(require("../styles/car-selector-tile.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  appendImageTransforms = dataUtils.appendImageTransforms;
var replaceThousandsSeperator = function replaceThousandsSeperator(priceString, currentSeperator, updatedSeperator) {
  var thousandsSeperatorRegExp = new RegExp("(\\d)(" + currentSeperator + ")(\\d)", 'g');
  return priceString.replace(thousandsSeperatorRegExp, "$1" + updatedSeperator + "$3");
};
var formatOverrideFunctions = {
  'nb-NO': function nbNO(priceString) {
    return replaceThousandsSeperator(priceString, ' ', '.');
  },
  'pt-PT': function ptPT(priceString) {
    return replaceThousandsSeperator(priceString, ' ', '.');
  }
};
var overrideFormatting = function overrideFormatting(locale, formattedPrice) {
  if (formatOverrideFunctions[locale] !== undefined) {
    formatOverrideFunctions[locale](formattedPrice);
  }
  return formattedPrice;
};
var localeSwap = {
  'ro-RO': 'es-ES',
  'fr-BE': 'es-ES',
  'es-ES': 'it-IT'
};
var shouldLocaleSwap = function shouldLocaleSwap(locale) {
  return locale in localeSwap ? localeSwap[locale] : locale;
};
var checkIfDecimalsTrue = function checkIfDecimalsTrue() {
  var _false = false,
    returnDecimal = _false.returnDecimal;
  if (returnDecimal === true) {
    return 2; // eslint-disable-line
  }
  return 0;
};
var formatPrice = function formatPrice(options) {
  var _true = true,
    returnZero = _true.returnZero;
  var currency = options.currency,
    locale = options.locale,
    value = options.value,
    zeroMessage = options.zeroMessage;

  // Testing if any of the props are not avalible and if the value is equal to 0
  if (value === 0) {
    if (typeof zeroMessage === 'string' && zeroMessage.length > 1) {
      return {
        zeroMessage: zeroMessage
      };
    }
    if (returnZero !== true) {
      return ' ';
    }
  }
  if (value === undefined || value === null || !locale || !currency) {
    return ' ';
  }
  var formattedPrice = new Intl.NumberFormat(shouldLocaleSwap(locale), {
    // eslint-disable-line
    style: 'currency',
    currency: currency,
    minimumFractionDigits: checkIfDecimalsTrue(),
    maximumFractionDigits: checkIfDecimalsTrue(),
    currencyDisplay: 'symbol'
  }).format(value);
  return overrideFormatting(locale, formattedPrice);
};
var CarSelectorTile = function CarSelectorTile(_ref) {
  var _div;
  var config = _ref.config,
    theme = _ref.theme,
    data = _ref.data,
    selected = _ref.selected,
    updateSelected = _ref.updateSelected,
    isForm = _ref.isForm,
    clickEvent = _ref.clickEvent,
    changeEvent = _ref.changeEvent,
    mouseDownEvent = _ref.mouseDownEvent,
    enableTwoColumns = _ref.enableTwoColumns,
    customizedLabel = _ref.customizedLabel,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData,
    itemIndex = _ref.itemIndex,
    selectedModelCodes = _ref.selectedModelCodes;
  var vehicleNextGenConfigurator = data.vehicleNextGenConfigurator,
    enableProductsRatingStars = data.enableProductsRatingStars,
    name = data.name,
    productSkuId = data.productSkuId;
  var imageWidth = 600;
  var cta = {
    label: handleNestedProp(data, 'data.cta.label'),
    url: handleNestedProp(data, 'data.cta.url')
  };
  var mobileColumns = enableTwoColumns || enableTwoColumns === 'true' ? 'col-xs-6' : 'col-xs-12';
  var getPriceDisclaimerId = function getPriceDisclaimerId() {
    return priceDisclaimerId;
  };
  var formatPriceWithCommas = function formatPriceWithCommas(price) {
    return Number(price).toLocaleString();
  };
  var getProductStarRatings = function getProductStarRatings() {
    return enableProductsRatingStars && /*#__PURE__*/_react["default"].createElement("div", {
      className: _carSelectorTile["default"].feefoWrapper
    }, _div || (_div = /*#__PURE__*/_react["default"].createElement("div", {
      className: "feefo-product-stars-widget",
      "data-product-sku": productSkuId
    })));
  };

  // eslint-disable-next-line no-shadow
  var getProductModelName = function getProductModelName(data, changeEvent) {
    var selectEvent = function selectEvent(event) {
      var carCode = data.code;
      var selectedIndex = event.target.selectedIndex;
      if (selectedIndex > 0 && selectedIndex <= data.models.length) {
        var modelCode = data.models[selectedIndex - 1].code;
        var modelPrice = data.models[selectedIndex - 1].price.value;
        var formattedPrice = formatPriceWithCommas(modelPrice);
        changeEvent(carCode, modelCode, formattedPrice);
      }
      if (typeof window !== 'undefined' && window.dataLayer) {
        var modelName = data.models[selectedIndex - 1].name;
        var _modelPrice = data.models[selectedIndex - 1].price.value;
        var _formattedPrice = formatPriceWithCommas(_modelPrice);
        window.dataLayer.push({
          event: 'comparison_selection',
          comparison: {
            modelYear: data.year,
            nameplate: data.name,
            trim: modelName,
            price: _formattedPrice
          }
        });
      }
      var target = event.target;
      target.value = '';
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _carSelectorTile["default"].dropDown
    }, /*#__PURE__*/_react["default"].createElement("select", {
      className: _carSelectorTile["default"].selectDropdown,
      onChange: selectEvent
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: ""
    }, data.selectTrimLabel), data.models.map(function (model, index) {
      var _model$price2;
      if (selectedModelCodes.includes(model.code)) {
        var _model$price;
        return /*#__PURE__*/_react["default"].createElement("option", {
          disabled: true,
          key: index,
          value: model.name
        }, model.name, model && model.price && model.price.value !== null && '- ', formatPrice({
          value: model == null ? void 0 : (_model$price = model.price) == null ? void 0 : _model$price.value,
          currency: handleNestedProp(config, 'config.currencyFormat'),
          locale: handleNestedProp(config, 'config.localeCode')
        }));
      }
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: index,
        value: model.name
      }, model.name, model && model.price && model.price.value !== null && '- ', formatPrice({
        value: model == null ? void 0 : (_model$price2 = model.price) == null ? void 0 : _model$price2.value,
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode')
      }));
    })));
  };

  // eslint-disable-next-line no-shadow
  var getProductModelCount = function getProductModelCount(data) {
    var modelCount = data.models.length;
    return /*#__PURE__*/_react["default"].createElement("p", null, data.trimCountText, " (", modelCount, ")");
  };
  if (isForm) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme[mobileColumns] + " " + theme['col-sm-6'] + " " + theme['col-md-4'] + " " + _carSelectorTile["default"].tileContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _carSelectorTile["default"].textContainer
    }, /*#__PURE__*/_react["default"].createElement(_commonOptionCard.CommonOptionCard, {
      onChange: function onChange() {
        return updateSelected(handleNestedProp(data, 'data.id'));
      },
      name: "hjdhfjdfhj(r",
      label: "",
      fullTap: true,
      isSelected: data.id === selected,
      type: "radio"
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, vehicleNextGenConfigurator && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.mmcBold + " " + _carSelectorTile["default"].ngcTagDesktop
    }, customizedLabel), /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      className: theme.marginBottom20 + " " + _carSelectorTile["default"].vehiclePic,
      src: appendImageTransforms(handleNestedProp(data, 'data.vehicleImage.image'), imageWidth),
      alt: handleNestedProp(data, 'data.vehicleImage.altText')
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _carSelectorTile["default"].infoContainer
    }, vehicleNextGenConfigurator && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.mmcBold + " " + _carSelectorTile["default"].ngcTagMobile
    }, customizedLabel), /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: name,
      className: theme.headingSix + " " + theme.marginBottom5,
      tag: "h2",
      disclaimerData: disclaimerData
    }), getProductStarRatings(), /*#__PURE__*/_react["default"].createElement(_carSelectorPrice["default"], {
      zeroMessage: handleNestedProp(data, 'data.price.zeroMessage'),
      pricevalue: handleNestedProp(data, 'data.price.displayValue'),
      price: handleNestedProp(data, 'data.price.value'),
      theme: theme,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: getPriceDisclaimerId(),
      disclaimerData: disclaimerData
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: _carSelectorTile["default"].selectButton + " " + theme.marginTop20
    }, /*#__PURE__*/_react["default"].createElement("span", null, handleNestedProp(data, 'data.selectLabel'))))))));
  }
  if (typeof clickEvent === 'function') {
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: theme[mobileColumns] + " " + theme['col-sm-6'] + " " + theme['col-md-4'] + " " + _carSelectorTile["default"].tileContainer,
      onClick: clickEvent,
      onMouseDown: mouseDownEvent,
      "data-destination": cta.url,
      type: "button",
      "data-linkindex": itemIndex
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + (enableTwoColumns ? _carSelectorTile["default"].textContainer : _carSelectorTile["default"].textContainerAside)
    }, vehicleNextGenConfigurator && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.mmcBold + " " + _carSelectorTile["default"].ngcTagDesktop
    }, customizedLabel), /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      className: _carSelectorTile["default"].vehiclePic,
      src: appendImageTransforms(handleNestedProp(data, 'data.vehicleImage.image'), imageWidth),
      alt: handleNestedProp(data, 'data.vehicleImage.altText')
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _carSelectorTile["default"].infoContainer
    }, vehicleNextGenConfigurator && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.mmcBold + " " + _carSelectorTile["default"].ngcTagMobile
    }, customizedLabel), /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: name,
      className: theme.headingSix + " " + _carSelectorTile["default"].vehicleName,
      tag: "h2",
      disclaimerData: disclaimerData
    }), getProductStarRatings(), /*#__PURE__*/_react["default"].createElement(_carSelectorPrice["default"], {
      zeroMessage: handleNestedProp(data, 'data.price.zeroMessage'),
      pricevalue: handleNestedProp(data, 'data.price.displayValue'),
      price: handleNestedProp(data, 'data.price.value'),
      theme: theme,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: getPriceDisclaimerId(),
      disclaimerData: disclaimerData
    }))));
  }
  if (typeof changeEvent === 'function') {
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: theme[mobileColumns] + " " + theme['col-sm-6'] + " " + theme['col-md-4'] + " " + _carSelectorTile["default"].tileContainers + " " + _carSelectorTile["default"].vehicleCompareTileContainers + " ",
      onMouseDown: mouseDownEvent,
      "data-destination": cta.url,
      type: "button",
      "data-linkindex": itemIndex
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + (enableTwoColumns ? _carSelectorTile["default"].textContainer : _carSelectorTile["default"].textContainerAside)
    }, vehicleNextGenConfigurator && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.mmcBold + " " + _carSelectorTile["default"].ngcTagDesktop
    }, customizedLabel), /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      className: _carSelectorTile["default"].vehiclePic,
      src: appendImageTransforms(handleNestedProp(data, 'data.vehicleImage.image'), imageWidth),
      alt: handleNestedProp(data, 'data.vehicleImage.altText')
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _carSelectorTile["default"].infoContainers
    }, vehicleNextGenConfigurator && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.mmcBold + " " + _carSelectorTile["default"].ngcTagMobile
    }, customizedLabel), /*#__PURE__*/_react["default"].createElement("div", {
      className: _carSelectorTile["default"].vehicleTextContainer
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: name,
      className: theme.headingSix + " " + _carSelectorTile["default"].vehicleNames,
      tag: "h2",
      disclaimerData: disclaimerData
    }), getProductModelName(data, changeEvent)), getProductStarRatings(), /*#__PURE__*/_react["default"].createElement(_carSelectorPrice["default"], {
      zeroMessage: handleNestedProp(data, 'data.price.zeroMessage'),
      pricevalue: handleNestedProp(data, 'data.price.displayValue'),
      price: handleNestedProp(data, 'data.price.value'),
      theme: theme,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: getPriceDisclaimerId(),
      disclaimerData: disclaimerData
    }), getProductModelCount(data))));
  }
  if (cta.url !== '') {
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: theme[mobileColumns] + " " + theme['col-sm-6'] + " " + theme['col-md-4'] + " " + _carSelectorTile["default"].tileContainer,
      href: cta.url,
      "data-linkindex": itemIndex,
      onMouseDown: mouseDownEvent
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + (enableTwoColumns ? _carSelectorTile["default"].textContainer : _carSelectorTile["default"].textContainerAside)
    }, vehicleNextGenConfigurator && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.mmcBold + " " + _carSelectorTile["default"].ngcTagDesktop
    }, customizedLabel), /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      className: theme.marginBottom20 + " " + _carSelectorTile["default"].vehiclePic,
      src: appendImageTransforms(handleNestedProp(data, 'data.vehicleImage.image'), imageWidth),
      alt: handleNestedProp(data, 'data.vehicleImage.altText')
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _carSelectorTile["default"].infoContainer
    }, vehicleNextGenConfigurator && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.mmcBold + " " + _carSelectorTile["default"].ngcTagMobile
    }, customizedLabel), /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: name,
      className: theme.headingSix + " " + theme.marginBottom5,
      tag: "h2",
      disclaimerData: disclaimerData
    }), getProductStarRatings(), /*#__PURE__*/_react["default"].createElement(_carSelectorPrice["default"], {
      zeroMessage: handleNestedProp(data, 'data.price.zeroMessage'),
      pricevalue: handleNestedProp(data, 'data.price.displayValue'),
      price: handleNestedProp(data, 'data.price.value'),
      theme: theme,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: getPriceDisclaimerId(),
      disclaimerData: disclaimerData
    }))));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme[mobileColumns] + " " + theme['col-sm-6'] + " " + theme['col-md-4'] + " " + _carSelectorTile["default"].tileContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + (enableTwoColumns ? _carSelectorTile["default"].textContainer : _carSelectorTile["default"].textContainerAside)
  }, vehicleNextGenConfigurator && /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.mmcBold + " " + _carSelectorTile["default"].ngcTagDesktop
  }, customizedLabel), /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    className: theme.marginBottom20 + " " + _carSelectorTile["default"].vehiclePic,
    src: appendImageTransforms(handleNestedProp(data, 'data.vehicleImage.image'), imageWidth),
    alt: handleNestedProp(data, 'data.vehicleImage.altText')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _carSelectorTile["default"].infoContainer
  }, vehicleNextGenConfigurator && /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.mmcBold + " " + _carSelectorTile["default"].ngcTagMobile
  }, customizedLabel), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: name,
    className: theme.headingSix + " " + theme.marginBottom5,
    tag: "h2",
    disclaimerData: disclaimerData
  }), getProductStarRatings(), /*#__PURE__*/_react["default"].createElement(_carSelectorPrice["default"], {
    pricevalue: handleNestedProp(data, 'data.price.displayValue'),
    price: handleNestedProp(data, 'data.price.value'),
    theme: theme,
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: getPriceDisclaimerId(),
    disclaimerData: disclaimerData
  }))));
};
CarSelectorTile.displayName = 'CarSelectorTile';
CarSelectorTile.defaultProps = {
  theme: {},
  data: _carSelectorGrid["default"].productTile[0]
};
var _default = CarSelectorTile;
exports["default"] = _default;